<template>
    <div
        v-if="blocks"
        class="theme-preview"
        :style="{ background: blocks.container?.background }">
        <div>
            <div
                class="theme-preview__title"
                :style="{ background: blocks.title?.fontColor }" />
            <div
                class="theme-preview__subtitle"
                :style="{ background: blocks.subTitle?.fontColor }" />
        </div>
        <div>
            <div
                v-for="i in 3"
                :key="i"
                class="theme-preview__paragraph-line"
                :style="{ background: blocks.paragraph?.fontColor }" />
        </div>
        <div class="theme-preview__button-container">
            <div
                class="theme-preview__button"
                :style="{ background: blocks.primaryButton?.background }" />
            <div
                class="theme-preview__button"
                :style="{ background: blocks.secondaryButton?.background }" />
            <div
                class="theme-preview__button"
                :style="{ background: blocks.tertiaryButton?.background }" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        theme: {
            required: true,
            type: Object,
        },
    },
    computed: {
        blocks () {
            return this.theme?.buildingBlocks;
        },
    },
};
</script>

<style lang="less" scoped>
.theme-preview {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-height: 100px;
    min-width: 100px;
    padding: 16px;

    &__title {
        border-radius: 2px;
        height: 16px;
        margin-bottom: 6px;
        width: 100%;
    }

    &__subtitle {
        border-radius: 2px;
        height: 8px;
        width: 80%;
    }

    &__paragraph-line {
        height: 4px;
        margin-bottom: 4px;
        width: 100%;
    }

    &__button-container {
        display: flex;
        gap: 6px;
    }

    &__button {
        border-radius: 2px;
        display: flex;
        flex-basis: 25%;
        height: 12px;
    }
}
</style>
